export function useMockedUser() {
  const raw = localStorage.getItem('user');
  const parsed = raw ? JSON.parse(raw) : null;
  const user = parsed
    ? {
        id: parsed.user_id ?? parsed.id ?? 'me',
        displayName: parsed.first_name
          ? `${parsed.first_name} ${parsed.last_name ?? ''}`.trim()
          : parsed.name ?? parsed.username ?? 'User',
        email: parsed.email ?? '',
        photoURL: parsed.photoURL ?? '',
        phoneNumber: parsed.phoneNumber ?? '',
        country: parsed.country ?? '',
        address: parsed.address ?? '',
        state: parsed.state ?? '',
        city: parsed.city ?? '',
        zipCode: parsed.zipCode ?? '',
        about: parsed.about ?? '',
        role: parsed.roles?.[0] ?? 'admin',
        isPublic: true,
      }
    : null;

  return { user };
}
